import { IHelp } from 'src/app/common/model/support.model';

export const HelpConstant: IHelp[] = [
  {
    _id: '1',
    title: 'Creating a Sale',
    shortDescription:
      'Embark on the journey of creating a sale by building relationships, understanding customer needs, and delivering value through persuasive communication, ultimately driving revenue growth.',
    icon: 'pi-plus',
    steps: [
      {
        title: 'Navigating to the POS View',
        description:
          'To access the Point of Sale (POS) view, click on the "New Sale" link in the sidebar menu.'
      },
      {
        title: 'Selecting Items',
        description:
          'Choose items by clicking on the respective rows or cards in the tile layout. The selected items will appear in the right column, where you can adjust the quantity as needed.'
      },
      {
        title: 'Generating an Invoice',
        description:
          'Once you have added the required items to the cart, follow these steps: 1. Link a customer by clicking on "Add Customer." 2. Select the due date for the invoice. You will then be redirected to the invoice page, where you can either share it via email or print it.'
      },
      {
        title: 'Checkout and Receipt',
        description:
          'After adding the required items to the cart, you can proceed to checkout. If necessary, link a customer, then click on "Checkout" to go to the payment page. Select the payment method, specify the amount to be paid (either full or partial), and complete the transaction. Upon completion, you will be redirected to the receipt page, where you can choose to send it via email or print it.'
      }
    ]
  },
  {
    _id: '2',
    title: 'Generating an Invoice',
    shortDescription:
      'Invoices are essential financial tools that ensure clear communication and facilitate timely payments between businesses and their customers.',
    icon: 'pi-file',
    steps: [
      {
        title: 'Navigating to the POS View',
        description:
          'To access the Point of Sale (POS) view, click on the "New Sale" link in the side menu.'
      },
      {
        title: 'Adding a Customer',
        description:
          'Before generating an invoice, it is mandatory to link a customer. Click on the "Add Customer" button to add the customer details.'
      },
      {
        title: 'Selecting the Due Date',
        description:
          'To generate an invoice, you must select a due date. After selection, you will be redirected to the invoice page, where you can choose to share it via email or print it.'
      }
    ]
  },
  {
    _id: '3',
    title: 'Adding a POS Item',
    shortDescription:
      'Enhance your decision-making process by tracking your POS items and gaining access to real-time sales data.',
    icon: 'pi-briefcase',
    steps: [
      {
        title: 'Navigating to the Item List View',
        description:
          'To access the Item List view, click on the "Manage items" link in the side menu, then select "Item list." In this view, you can either upload multiple items through an Excel file or add a single item.'
      },
      {
        title: 'Uploading Multiple Items',
        description:
          'To upload multiple items, click on the "Upload" button in the table header and select "Download Sample Excel File" to obtain an Excel file with the required format. Rename the columns in your Excel file to match those in the sample, then click on the "Choose" button in the opened modal to upload the file to EBM Suite. Voila! Your items will be uploaded successfully.'
      },
      {
        title: 'Adding a Single Item',
        description:
          'To add a single item, click on the "Add" button in the table header. You will be redirected to the create item page, where you can enter the required details in the corresponding fields. If all information is provided correctly, the "Save" button will become active. Click on it to save the new item.'
      }
    ]
  }
];
